import adminApi from "api/admin";
import {IEnterpriseEntry} from "api/types";
import {ThankYouCheckIcon} from "assets/icons";
import Modal from "components/Modal";
import ModalLayout from "components/ModalLayout";
import {handleError} from "helpers/errors";
import {AwaitableModal} from "hooks/useAwaitableModal";
import {useState} from "react";

const NewEnterpriseModal: AwaitableModal<IEnterpriseEntry | undefined> = ({open, resolve}) => {
  const [email, setEmail] = useState<string>("");
  const [name, setName] = useState<string>("");
  const [link, setLink] = useState<string>();
  const [created, setCreated] = useState<IEnterpriseEntry>();
  const [submitting, setSubmitting] = useState(false);

  const emailValid = email?.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g);

  const onCreate = () => {
    if (submitting) return;
    if (!email) return handleError("Please enter the email");
    if (!emailValid) return handleError("Please enter a valid email");
    if (!name) return handleError("Please enter the name");
    setSubmitting(true);
    adminApi
      .createEnterprise({email, name})
      .then(async ({user, passwordResetLink}) => {
        setCreated(user);
        const sp = new URLSearchParams(passwordResetLink);
        const code = sp.get("oobCode");
        if (!code) return handleError("An error occurred");
        setLink(window.location.origin + `/auth/reset-password?code=${code}`);
        if (user && !passwordResetLink) resolve(user);
      })
      .finally(() => setSubmitting(false));
  };

  const onResolve = () => resolve(created);

  if (link) {
    return (
      <Modal open={open} close={onResolve}>
        <ModalLayout
          title="Enterprise Created"
          footer={
            <button onClick={onResolve} className="btn-primary ml-auto">
              Done
            </button>
          }
        >
          <div className="flex flex-col items-center gap-3 py-2">
            <ThankYouCheckIcon className="h-24" />
            <p className="text-sm text-brand-muted text-center">Send the password reset link below to the user.</p>
          </div>
          <input type="text" value={link} readOnly className="w-full" />
        </ModalLayout>
      </Modal>
    );
  }

  return (
    <Modal open={open} close={!submitting ? onResolve : () => {}}>
      <ModalLayout
        title="Create an Enterprise"
        footer={
          <>
            <button className="btn-secondary" disabled={submitting} onClick={!submitting ? onResolve : () => {}}>
              Cancel
            </button>
            <button className="btn-primary" disabled={submitting} onClick={onCreate}>
              Create
            </button>
          </>
        }
      >
        <input type="text" placeholder="Name" value={name} onChange={(e) => setName(e.currentTarget.value)} />
        <input
          type="text"
          placeholder="Email Address"
          value={email}
          onChange={(e) => setEmail(e.currentTarget.value)}
        />
      </ModalLayout>
    </Modal>
  );
};

export default NewEnterpriseModal;
